<template>
	<b-card no-body>
		<b-tabs no-fade pills card small vertical nav-class="nav-style">
			<b-tab title="General" active>
				<ModelForm
					:modelId="modelId"
					resource="sales-channels"
					:modelInfo="defaultModelInfo"
					v-slot="slotProps"
					@fetch="$emit('update:unableEdit',!$hasPermission('channel.edit'))"
					:params.sync="defaultModelInfo"
					:successCallback="successCallback"
				>
					<b-form-row>
						<b-form-group :disabled="unableEdit" class="col-4" label="Codigo">
							<b-form-input
								type="text"
								size="sm"
								v-model="slotProps.modelInfo.code"
								required
							/>
						</b-form-group>
						<b-form-group :disabled="unableEdit" class="col-4" label="Nombre">
							<b-form-input
								type="text"
								size="sm"
								v-model="slotProps.modelInfo.name"
								required
							/>
						</b-form-group>
						<b-form-group :disabled="unableEdit" class="col-4" label="Estado">
							<b-form-select
								size="sm"
								v-model="slotProps.modelInfo.status"
								:options="statusOptions"
							></b-form-select>
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group :disabled="unableEdit" class="col-6" label="Descripcion">
							<b-textarea
								size="sm"
								v-model="slotProps.modelInfo.description"
							/>
						</b-form-group>
					</b-form-row>
					<hr />
					<div class="text-right">
						<b-button :disabled="unableEdit" variant="primary" type="submit">{{
							modelId > 0 ? "Actualizar" : "Guardar"
						}}</b-button>
					</div>
				</ModelForm>
			</b-tab>
			<b-tab
				v-if="modelId > 0 && this.$hasPermission('channel.ratePlan') "
				title="Destinos y Tarifas"
			>

				<FormGroupBox title="Destinos">
					<template #append-title>
						<b-button
							size="sm"
							v-if="$hasPermission('rates.add')"
							variant="success"
							@click="addRatePlan"
							><md-icon icon="add"
						/></b-button>
					</template>
					<b-table
						responsive
						:fields="ratePlansColumns"
						striped
						hover
						bordered
						:items="ratePlans"
					>
						<template v-slot:cell(percentageDiscount)="row">
							{{ row.item.percentageDiscount }} %
						</template>
						<template v-slot:cell(startDate)="row">
							<div class="d-flex flex-column"
								:class="[
									isValidateDate(row.item.endDate) ? '' : 'text-danger',
								]"
							>
								<span class="u:text-size-2 text-muted m-0">
									{{
									row.item.startDate != null
										? formatDate(row.item.startDate, "DD/MM/YYYY")
										: "Pendiente"
									}}
								</span>
							</div>
						</template>
						<template v-slot:cell(endDate)="row">
						<div
							class="d-flex flex-column"
							:class="[
								isValidateDate(row.item.endDate) ? '' : 'text-danger',
							]"
							>
							<span class="u:text-size-2 text-muted m-0"
								><md-icon
								icon="info"
								:class="[
									row.item.endDate == null
									? ''
									: isValidateDate(row.item.endDate)
									? 'text-success'
									: 'text-danger',
								]"
								:content="
									row.item.endDate == null
									? 'Vecimiento no configurado'
									: isValidateDate(row.item.endDate)
									? 'Tarifa activa'
									: 'Tarifa expirado'
								"
								v-tippy="{ arrow: true, arrowType: 'round' }"
								/>
								{{
								row.item.endDate != null
									? formatDate(row.item.endDate, "DD/MM/YYYY")
									: "Pendiente"
								}}
							</span>
							</div>
						</template>
						<template v-slot:cell(actions)="row">
							<div class="text-center">
								<a
									v-if="row.item.parentRatePlanId <= 0 && $hasPermission('prices.show')"
									:href="`/rate-plans-edit?id=${row.item.id}`"
									target="_blank"
									class="btn btn-sm mr-1 btn-warning"
								>
									<md-icon icon="attach_money" />
								</a>
								<b-button
									@click="event => viewRatePlan(row.item.id)"
									type="button"
									size="sm"
									class="mr-1"
									variant="primary"
								>
									<md-icon icon="edit" />
								</b-button>
								<b-button
									@click="
										event =>
											deleteRatePlan(
												row.item,
												row.index,
												event
											)
									"
									type="button"
									v-if="$hasPermission('rates.delete')"
									size="sm"
									class="mr-1"
									variant="danger"
								>
									<md-icon icon="delete" />
								</b-button>
								<b-dropdown
									v-if="$hasPermission('rates.expire')"
									id="dropdown-1"
									text="Dropdown Button"
									variant="success"
									size="sm"
									class="mr-1"
									content="Cierre de tarifa"
									v-tippy="{ arrow: true, arrowType: 'round' }"
								>
									<template #button-content
									><md-icon icon="price_check" />
									</template>
									<b-dropdown-item
										@click="showOpcionsDateRate(row.item, 'expire')"
										>Config. expiración de tarifa</b-dropdown-item
									>
									<b-dropdown-item
										@click="
										showOpcionsDateRate(row.item, 'expireAndDuplicate')
										"
									>Config. expiración y duplicar tarifa</b-dropdown-item
									>
								</b-dropdown>
							</div>
						</template>
					</b-table>
				</FormGroupBox>
				<RatePlanSingle
					:unableEdit="unableEditRate"
					ref="ratePlanSingle"
					:success-callback="successCallbackRatePlan"
				/>
			</b-tab>

			<b-tab v-if="modelId > 0 && this.$hasPermission('channel.ratePlan') " title="Promociones" lazy>
				<h1>Promociones</h1>
				<PromotionsList :salesChannelId="modelId"></PromotionsList>
			</b-tab>
			<b-tab
				v-if="modelId > 0 && $hasPermission('channel.contact.show')"
				@click="
					loadedTabs.push('contacts');
					currentTab = 'contacts';
				"
				title="Contactos"
			>
				<Contacts
					v-if="loadedTabs.includes('contacts')"
					:model-id="modelId"
				/>
			</b-tab>
			<b-tab title="Configuración" v-if="$hasPermission('channel.config')">
				<b-row>
					<b-col>
						<table class="table table-striped">
							<tr>
								<th></th>
								<th>Opción</th>
								<th>Descripcion</th>
							</tr>
							<tr>
								<td> <b-form-checkbox :disabled="unableEdit" size="lg" v-model="defaultModelInfo.settingVars.blockEdit"></b-form-checkbox> </td>
								<td>Bloquear reservas</td>
								<td>Los clientes NO podrán modificar su reserva a través del portal Web Check-in</td>
							</tr>
							<tr>
								<td> <b-form-checkbox :disabled="unableEdit" size="lg" v-model="defaultModelInfo.settingVars.compareRates"></b-form-checkbox> </td>
								<td>Comparación de precios</td>
								<td>Comparar el precio registrado en la reserva con el calculo de tarifas</td>
							</tr>
							<tr>
								<td> <b-form-checkbox :disabled="unableEdit" size="lg" v-model="defaultModelInfo.settingVars.updateRatesByCalculation"></b-form-checkbox> </td>
								<td>Actualización de precios</td>
								<td>Actualizar el precio registrado en la reserva con el calculo de tarifas de forma automática. Se realizara el calculo y actualización siempre que la tarifa de venta no este marcada con la opción "Mantener precio". Tampoco se actualizaran reservas hechas en puntos de venta.</td>
							</tr>
						</table>
						<b-button :disabled="unableEdit" @click="updateSettings()" variant="primary">Actualizar</b-button>
					</b-col>
				</b-row>
			</b-tab>
		</b-tabs>

		<!-- modal cierre de tarifa -->
		<b-modal
			hide-footer
			ref="refClosingRate"
			size="md"
			:title="
				TypeOfClousure == 'expire'
				? 'Config. expiración de tarifa'
				: 'Config. expiración y duplicar tarifa'
			"
			>
			<ClosingRateModal
				@closeModal="$refs['refClosingRate'].hide()"
				ref="refBodyCloseRate"
				:TypeOfClousure="TypeOfClousure"
				@refreshTableRate="loadRatePlans()"
			/>
		</b-modal>
	</b-card>
</template>

<script>
import moment from "moment";
import ModelForm from "../../helpers/ModelForm.vue";
import FormGroupBox from "../../helpers/FormGroupBox";
import RatePlanSingle from "../rate-plans/Single";
import ClosingRateModal from "../rate-plans/ClosingRateModal.vue";
import Contacts from "../sales-channel-contacts/Index.vue";
import PromotionsList from "./IndexPromotions.vue";

export default {
	props: {
		unableEdit: Boolean,
		modelId: {
			type: Number,
			required: false,
			default: -1
		},
		modalId: {
			type: String,
			required: true
		}
	},
	components: { ModelForm, FormGroupBox, RatePlanSingle, Contacts, ClosingRateModal , PromotionsList },
	data() {
		return {
			unableEditRate: false,
			loading: true,
			loadedTabs: [],
			ratePlans: [],
			defaultModelInfo: {
				id: -1,
				code: "",
				name: "",
				description: "",
				status: "active",
				settingVars: {
					blockEdit: false,
					compareRates: true,
					updateRatesByCalculation: true,
				},
			},
			statusOptions: [
				{ value: "active", text: "Activo" },
				{ value: "inactive", text: "Inactivo" }
			],
			ratePlansColumns: [
				{ key: "id", label: "ID" },
				{ key: "name", label: "Nombre" },
				{ key: "zonedAreaName", label: "Area" },
				{ key: "currency", label: "Moneda" },
				{ key: "heritance", label: "Conf. Herencia" },
				{ key: "percentageDiscount", label: "Descuento" },
				{ key: "rateType", label: "Tipo" },
				{ key: "startDate", label: "F.Inicio", sortable: true },
				{ key: "endDate", label: "F.Vecimiento", sortable: true },
				{ key: "actions", label: "Acciones" }
			],
			currentTab: "general",
			TypeOfClousure: "expire",
		};
	},
	computed: {},
	methods: {
		formatDate(date, format) {
			return moment(date).format(format);
		},
		deleteRatePlan(item) {
			this.$root.showWarning({
				okAction: (event, setLoading, close) => {
					setLoading(true);
					this.$root.api
						.delete(`/rate-plans/${item.id}/sales-channel/${this.modelId}`)
						.then(() => {
							this.$root.showAlert("Registro Eliminado!", {
								variant: "warning"
							});
							this.loadRatePlans();
							close();
						})
						.catch(err => {
							this.$root.handleRequestError(err);
							close();
						});
				}
			});
		},
		viewRatePlan(id) {
			this.unableEditRate =  !this.$hasPermission("rates.edit")
			this.$refs["ratePlanSingle"].loadModel(id);
		},
		addRatePlan() {
			this.unableEditRate = false;
			this.$refs["ratePlanSingle"].loadModel(-1);
			this.$refs["ratePlanSingle"].setSalesChannelId(this.modelId);
		},
		loadRatePlans() {
			if (this.modelId > 0 ) {
				this.$root.api
					.get(`/sales-channels/${this.modelId}/rate-plans`)
					.then(res => {
						this.ratePlans = res.data;
					})
					.catch(this.$root.handleRequestError);
			}
		},
		successCallback(event) {
			if(event.data?.id) this.$emit('model-id',event.data.id);
			this.loadRatePlans();
			this.$root.auxVars.loadResourcesOpts({
				vm: this,
				resourceNames: ["salesChannelsOpts"],
				forceRefresh: true
			});
		},
		updateSettings() {
			let settings = {
				blockEdit : this.defaultModelInfo.settingVars.blockEdit,
				compareRates : this.defaultModelInfo.settingVars.compareRates,
				updateRatesByCalculation : this.defaultModelInfo.settingVars.updateRatesByCalculation,
			}

			this.$root.api.put(`/sales-channels/${this.modelId}/setting-vars`,{ settings }).then(() => {
				this.$root.showAlert('Configuraciones actualizadas')
				this.loading = false
			}).catch(this.$root.handleRequestError);
		},
		successCallbackRatePlan() {
			this.loadRatePlans();
		},
		isValidateDate(fecha) {
			//validamos que el campo sea distinto de null
			if (fecha != null) {
				//obtenemos la fecha actual
				let today = moment().format("YYYY-MM-DD h:mm:ss");
				return (
					moment(today).toDate() <= moment(fecha, "YYYY-MM-DD h:mm:ss").toDate()
				);
			}
			return false;
		},
		showOpcionsDateRate(itemRate, status) {
			let me = this;
			this.$refs["refClosingRate"].show();
			setTimeout(function () {
				me.$refs.refBodyCloseRate.setTypeOfClousure(status);
				me.$refs.refBodyCloseRate.setRate(itemRate);
			}, 200);
		},
	},
	mounted() {
		this.loadRatePlans();
	},
	watch: {
		modelId: function() {
			this.loadRatePlans();
		}
	}
};
</script>

<style></style>
